import { useTracking } from '@change-corgi/core-react/tracking';

import { useImpactStoryPageData } from 'src/app/pages/impactStory/pageContext';

type Result = ModelHookResult<
	{
		video: string | null;
		imageUrl: string | null;
		title: string;
		signatureCount: number;
		signatureCountLocalized: string;
		badgeLabel: string;
		paragraphs: readonly string[];
		petitionUrl: string;
		hasGuides: boolean;
	},
	{
		trackPetitionUrlClick: () => void;
	}
>;

export function usePageBody(): Result {
	const {
		data: {
			petition: {
				slug,
				signatureState: {
					signatureCount: { displayed, displayedLocalized },
				},
			},
			featureConfig: {
				story: { videoUrl: video, title, paragraphs, badgeLabel, imageUrl },
				guides,
				guidesEnabled,
			},
		},
	} = useImpactStoryPageData();
	const track = useTracking();

	return {
		data: {
			video,
			imageUrl,
			title,
			paragraphs,
			badgeLabel,
			petitionUrl: `/p/${slug}`,
			hasGuides: guidesEnabled && guides.length > 0,
			signatureCount: displayed,
			signatureCountLocalized: displayedLocalized,
		},
		actions: {
			trackPetitionUrlClick: () => {
				void track('impact_story_page_petition_url_click');
			},
		},
	};
}
